export type TopNavId =
  | 'home'
  | 'trader'
  | 'signals'
  | 'radar'
  | 'invest'
  | 'fractal';

export interface TopNav {
  id: TopNavId;
  label: string;
}

export const TOP_NAVS: readonly TopNav[] = [
  { id: 'home', label: 'Home' },
  { id: 'trader', label: 'Trader' },
  { id: 'signals', label: 'Signals' },
  { id: 'radar', label: 'Radar' },
  { id: 'invest', label: '全球投资' },
  { id: 'fractal', label: '分形演化论' },
] as const;
